import { useFormik } from 'formik'
import * as Yup from 'yup'
import styles from './CreditsTable.module.css'

const validationSchema = Yup.object({
  limit: Yup.number().min(0, 'Min 0').required('Required'),
  used_license: Yup.number().min(0, 'Min 0').required('Required'),
  status: Yup.string().oneOf(['Active', 'Inactive']).required('Required'),
})

const EditableRow = ({ row, onSave, onCancel, isSaving }) => {
  const handleSubmit = (values) => {
    onSave(row.id, values)
  }

  const formik = useFormik({
    initialValues: {
      limit: row.limit,
      used_license: row.used_license,
      status: row.status,
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  return (
    <tr className={styles.tableBodyRow}>
      <td className={styles.td}>{row.id}</td>
      <td className={styles.td}>{row.username}</td>
      <td className={styles.td}>{row.license_key}</td>
      <td className={styles.td}>
        <form onSubmit={formik.handleSubmit}>
          <input
            className={styles.input}
            type='number'
            name='limit'
            min={0}
            value={formik.values.limit}
            onChange={formik.handleChange}
            disabled={isSaving}
          />
          {formik.touched.limit && formik.errors.limit && <div className={styles.error}>{formik.errors.limit}</div>}
        </form>
      </td>
      <td className={styles.td}>
        <form onSubmit={formik.handleSubmit}>
          <input
            className={styles.input}
            type='number'
            name='used_license'
            min={0}
            max={formik.values.limit}
            value={formik.values.used_license}
            onChange={formik.handleChange}
            disabled={isSaving}
          />
          {formik.touched.used_license && formik.errors.used_license && (
            <div className={styles.error}>{formik.errors.used_license}</div>
          )}
        </form>
      </td>
      <td className={styles.td}>
        <form onSubmit={formik.handleSubmit}>
          <select
            className={styles.select}
            name='status'
            value={formik.values.status}
            onChange={formik.handleChange}
            disabled={isSaving}
          >
            <option value='Active'>Active</option>
            <option value='Inactive'>Inactive</option>
          </select>
          {formik.touched.status && formik.errors.status && <div className={styles.error}>{formik.errors.status}</div>}
        </form>
      </td>
      <td className={styles.td}>
        <form onSubmit={formik.handleSubmit}>
          <button className={styles.saveBtn} type='submit' disabled={isSaving}>
            {isSaving ? (
              <span className={styles.loadingIndicator}>
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            ) : (
              'Save'
            )}
          </button>
          <button className={styles.cancelBtn} onClick={onCancel} type='button' disabled={isSaving}>
            Cancel
          </button>
        </form>
      </td>
    </tr>
  )
}

export default EditableRow
